import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';


export const apiCallIds = {
  FETCH_QUESTION: 'FETCH_QUESTION',
  FETCH_QUESTIONS: 'FETCH_QUESTIONS',
  UPDATE_QUESTION: 'UPDATE_QUESTION',
  CREATE_QUESTION: 'CREATE_QUESTION',
  FETCH_QUESTION_COUNT: 'FETCH_QUESTION_COUNT'
};

export default {

  createQuestion: question => {
    return apiClient.post('/help', question ,
        { apiCallId: apiCallIds.CREATE_QUESTION, }
    );
  },


  fetchQuestion: questionId => {
    return apiClient.get(`/help/${questionId}`, {
      apiCallId: apiCallIds.FETCH_QUESTION,
    });
  },

  fetchQuestions: options => {
    return apiClient.get(`/help?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_QUESTIONS
    });
  },

  updateQuestion: payload => {
    return apiClient.put(`/help/${payload.questionId}`, payload ,{
      apiCallId: apiCallIds.UPDATE_QUESTION,
    });
  },

  fetchQuestionCount: options => {
    return apiClient.get(`/helpCount?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_QUESTION_COUNT,
    })
  }

}


// WEBPACK FOOTER //
// ./src/features/help-management/api/index.js